/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Po_Tab_ChangesInputs */

const en_po_tab_changes = /** @type {(inputs: Po_Tab_ChangesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposals`)
};

/**
* | output |
* | --- |
* | "Proposals" |
*
* @param {Po_Tab_ChangesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const po_tab_changes = /** @type {((inputs?: Po_Tab_ChangesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Po_Tab_ChangesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_po_tab_changes(inputs)
});